import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledCredit,
  StyledText,
  StyledAuthor,
  StyledSeccion,
  StyledAvatarPerson
} from './style';

import Avatar from './Avatar';
import { AVATAR_MEDIUM } from '../../../utils/crops';

const Credit = ({ className, hover, author }) => {
  const {
    user,
    association: { name },
    alias
  } = author;
  const { completeName, username, userlastname, userId, avatarPhoto } = user;
  const authorName = completeName || alias;
  const associationName = name;
  const speakerAvatar =
    !username && (alias || associationName) ? (
      <Avatar pathImage="/crops/liberty" />
    ) : null;

  return (
    <StyledCredit className={className} hover={hover}>
      {username && (
        <StyledAvatarPerson
          name={user.name}
          lastname={userlastname}
          className="credit-avatar"
          userId={String(userId)}
          crop={AVATAR_MEDIUM}
          avatarPhoto={avatarPhoto}
        />
      )}
      {speakerAvatar}
      <StyledText>
        {authorName && <StyledAuthor>{authorName}</StyledAuthor>}
        {associationName && <StyledSeccion>{associationName}</StyledSeccion>}
      </StyledText>
    </StyledCredit>
  );
};

Credit.propTypes = {
  author: PropTypes.shape({
    user: PropTypes.shape({
      name: PropTypes.string,
      avatarPhoto: PropTypes.bool
    }),
    association: PropTypes.shape({
      name: PropTypes.string
    }),
    alias: PropTypes.string
  }),
  className: PropTypes.string,
  hover: PropTypes.bool
};

export default Credit;
